import { render, staticRenderFns } from "./DescargasActividad.vue?vue&type=template&id=cfda2b5c&"
import script from "./DescargasActividad.vue?vue&type=script&lang=ts&"
export * from "./DescargasActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cfda2b5c', component.options)
    } else {
      api.reload('cfda2b5c', component.options)
    }
    module.hot.accept("./DescargasActividad.vue?vue&type=template&id=cfda2b5c&", function () {
      api.rerender('cfda2b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/DescargasActividad.vue"
export default component.exports